import React from 'react'
import style from './MainBlock.module.css'
import { WindowsMainLogo } from '../../../Assets/Icons/Windows'

const MainBlock = () => {

  return (
    <section className={style.hero}>
      <div className={`customContainer ${style.hero__inner}`}>
        <div className={style.hero__top}>
          <div className={style.hero__brand}>
            <img
              className={style.hero__logo}
              src={WindowsMainLogo}
              alt="Logo"
            />

            <div className={style.hero__titleWrap}>
              <h1 className={style.hero__title}>Windows for every need</h1>
              <span className={style.hero__line} />
            </div>
          </div>
        </div>

        <div className={style.hero__bottom}>
          <div className={style.hero__card}>
            <div className={style.hero__card_wrap}>
              <span className={style.hero__cardLine} />

              <p className={style.hero__cardText}>
                European tilt & turn windows are a perfect blend of advanced engineering, elegant aesthetics, and proven
                durability. Designed to keep warmth and tranquility inside your home, they provide lasting comfort
                through
                every season.
              </p>
            </div>

            <a
              href={'/catalog.pdf'} target="_blank"
              rel="noopener noreferrer"
              className={style.hero__scrollBtn} type="button">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M13 11L21.2 2.79999" stroke="#111111" stroke-width="1.74545" stroke-linecap="round"
                      stroke-linejoin="round" />
                <path d="M21.9992 6.8V2H17.1992" stroke="#111111" stroke-width="1.74545" stroke-linecap="round"
                      stroke-linejoin="round" />
                <path d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13" stroke="#111111"
                      stroke-width="1.74545" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>Open our in-stock Window Catalogue</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MainBlock
